<template>
    <div>
        <div class="top-box">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>需求管理</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="tab-list d_flex a_c ">
                <h2>需求列表</h2>
            </div>
        </div>
        <div class="page-content p20">
            <div class="table p20 bg_fff">
                <el-table :data="tableList" border v-loading="loading" style="width: 100%">
                    <el-table-column prop="name" label="需求类型" align="center">
                        <template slot-scope="scope">
                            <span>{{scope.row.type==1?'场地申请':'场地预定'}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="space_name" label="目标名称" align="center">
                    <template slot-scope="scope">
                       <span v-if="scope.row.type==1">{{scope.row.space_name}}</span>
                    </template>
                    </el-table-column>
                    <el-table-column prop="city" label="所属城市" align="center"/>
                    <el-table-column prop="cate_name" label="目标类型" align="center"/>
                    <el-table-column prop="cate_name" label="活动时间" align="center">
                        <template slot-scope="scope">
                            <span>{{scope.row.activity_date}}-{{scope.row.end_date}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="activity_budget" label="价格" align="center"/>
                    <el-table-column prop="area" label="面积" align="center"/>
                    <el-table-column prop="user_name" label="用户名称" align="center"/>
                    <el-table-column prop="user_mobile" label="联系方式" align="center"/>
                    <el-table-column prop="check_remark" label="备注" align="center"/>
                    <el-table-column prop="remark" label="状态" align="center">
                        <template slot-scope="scope">
                            <span>{{scope.row.status==1?'已处理':'待处理'}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column fixed="right" label="操作" align="center" width="180px">
                        <template slot-scope="scope" >
                            <el-button type="text" v-if="scope.row.status!=1" size="small" @click="handleOrder(scope.row)">处理</el-button>
                            <el-button type="text" v-if="role_id==1||role_id==5" size="small" @click="deleteOrder(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                        background
                        layout="prev, pager, next"
                        :total="pages"
                        :current-page="page"
 :page-size="20"
                        @current-change="handleCurrentChange"
                        style="margin-top: 20px; text-align: right;"
                >
                </el-pagination>
            </div>
        </div>
        <el-dialog title="需求处理" :visible.sync="popup">
            <el-form :model="form">
                <el-form-item label="处理备注" label-width="120">
                    <el-input v-model="form.remark" type="textarea" autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="closePop">取 消</el-button>
                <el-button type="primary" @click="subOrder">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {bookList,bookUp_status} from '../../api/index'
    import {delBook} from '../../api/order'
    export default {
        name: "demand",
        data(){
            return{
                loading:true,
                page:1,
                pages:1,
                tableList:[],
                form:{
                    book_id:'',
                    remark:''
                },
                popup:false,
                role_id:0
            }
        },
        mounted(){
            this.bookList();
            this.role_id=localStorage.getItem('ROLE');
        },
        methods:{
            bookList(){
                this.loading=true;
                bookList({
                    p:this.page
                }).then(res=>{
                    this.loading=false;
                    if(res.code==1){
                        this.tableList=res.data.list;
                        this.pages=res.data.total_num;
                    }
                })
            },
            handleCurrentChange(val){
                this.page = val;
                this.bookList()
            },
            handleOrder(row){
                this.popup=true;
                this.form.book_id=row.book_id;

            },
            subOrder(){
                bookUp_status(this.form).then(res=>{
                    if(res.code==1){
                        this.$message.success('处理成功');
                        this.closePop();
                        this.bookList();
                    }else{
                        this.$message.error(res.msg);
                    }
                })
            },
            closePop(){
                this.form.book_id='';
                this.form.remark='';
                this.popup=false;
            },
            deleteOrder(row){
                this.$confirm('此操作将永久删除该需求, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    delBook({book_id:row.book_id}).then(res=>{
                        if(res.code==1){
                            this.$message.success('删除成功');
                            this.bookList();
                        }else{
                            this.$message.err(res.msg);
                        }
                    })
                })
            }

        }
    }
</script>

<style lang="scss" scoped>

</style>
